import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const Check = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 448 512"
      {...props}
    >
      <path d="" />
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
      />
    </SvgIcon>
  );
};
